export class MixedColour { 
    public name: string;
    public textureKey: string;
    public swatchImageUrl: string;

    constructor({ name, textureKey, swatchImageUrl } : { name: string, textureKey: string, swatchImageUrl: string }) {
        this.name = name;
        this.textureKey = textureKey;
        this.swatchImageUrl = swatchImageUrl;
    }
}